import type { AdminSession } from '../../types'
import { sortSessions, toSession } from './securityMappers'

type Translator = (key: string, params?: Record<string, string | number>) => string

export const mapSecuritySessions = (t: Translator, sessionsPayload: unknown[]): AdminSession[] =>
  sortSessions(
    sessionsPayload
      .map((session: unknown) => toSession(t, session))
      .filter((session: AdminSession) => Boolean(session.id)),
  )

export const mergeSecuritySession = (
  sessions: AdminSession[],
  nextSession: AdminSession,
): AdminSession[] => sortSessions([nextSession, ...sessions.filter((item) => item.id !== nextSession.id)])
